import DocumentationButton from "components/DocumentationButton";
import { LogoSpaceliftColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

import AiCreateIntegrationButton from "./components/CreateIntegrationButton";

const AiIntegrationsEmpty = () => {
  return (
    <EmptyState
      title="You don't have any AI integrations yet."
      caption="AI integrations allow you to use large language models to manage your infrastructure using natural language."
      icon={LogoSpaceliftColored}
    >
      <Box gap="medium">
        <AiCreateIntegrationButton />
        <DocumentationButton
          to={getDocsUrl("/integrations/ai")}
          label="Documentation"
        />
      </Box>
    </EmptyState>
  );
};

export default AiIntegrationsEmpty;
